/**
 * Flanger - Effet de flanging
 * Comme un chorus mais avec feedback pour un son plus métallique
 */

import * as Tone from 'tone';

export class Flanger {
    constructor() {
        // Le flanger utilise un FeedbackDelay modulé par un LFO
        this.lfo = new Tone.LFO({
            frequency: 0.2,
            min: 0.001,
            max: 0.005,
            type: 'sine'
        }).start();

        this.delay = new Tone.FeedbackDelay({
            delayTime: 0.003,
            feedback: 0.5,
            wet: 1
        });

        this.lfo.connect(this.delay.delayTime);

        this.input = this.delay;

        this._rate = 0.2;
        this._depth = 0.5;
        this._feedback = 0.5;
        this._mix = 0.3;
        this._isActive = true;

        this._outputGain = new Tone.Gain(this._mix);
        this.delay.connect(this._outputGain);
        this.output = this._outputGain;
    }

    get rate() { return this._rate; }
    get depth() { return this._depth; }
    get feedback() { return this._feedback; }
    get mix() { return this._mix; }

    setRate(hz) {
        this._rate = hz;
        this.lfo.frequency.value = hz;
    }

    setDepth(depth) {
        this._depth = depth;
        // Ajuste la plage du LFO
        this.lfo.min = 0.001;
        this.lfo.max = 0.001 + (depth * 0.009);
    }

    setFeedback(fb) {
        this._feedback = fb;
        this.delay.feedback.value = fb;
    }

    setMix(mix) {
        this._mix = mix;
        this._outputGain.gain.value = mix;
    }

    connectTo(destination) {
        this.output.connect(destination);
    }

    disconnect() {
        this.output.disconnect();
    }

    /**
     * Active/désactive l'effet (économie CPU)
     * Sets LFO frequency to 0 when inactive
     * @param {boolean} active - true pour activer, false pour désactiver
     */
    setActive(active) {
        if (active === this._isActive) return;
        this._isActive = active;

        if (active) {
            this.lfo.frequency.value = this._rate;
        } else {
            this.lfo.frequency.value = 0;
        }
    }

    getParams() {
        return {
            rate: this._rate,
            depth: this._depth,
            feedback: this._feedback,
            mix: this._mix
        };
    }

    setParams(params) {
        if (params.rate !== undefined) this.setRate(params.rate);
        if (params.depth !== undefined) this.setDepth(params.depth);
        if (params.feedback !== undefined) this.setFeedback(params.feedback);
        if (params.mix !== undefined) this.setMix(params.mix);
    }

    dispose() {
        this.lfo.dispose();
        this.delay.dispose();
        this._outputGain.dispose();
    }
}
